import mail from './mail';
import auth from './auth';

export default [
  mail.send,
  ...auth,
];
